import axios from "axios";
import { getCookie } from "../helpers/common";
import { toast } from "react-toastify";
import { getEnv } from "helpers/environment";
import { handleFetchAuth0Token } from "./ExecutorServiceApi";

const makeRequest = async (data, retryOnFail) => {
  const accessToken = await handleFetchAuth0Token();

  try {
    const response = await axios({
      method: "post",
      url: getEnv("UDAS_API"),
      maxBodyLength: Infinity,
      data: data,
      headers: {
        "Content-Type": "application/json",
        "Apollo-Require-Preflight": true,
        Authorization: "Bearer " + accessToken,
        withCredentials: true
      }
    });
    return response?.data?.data;
  } catch (error) {
    console.log("error", error);

    if (!retryOnFail && error.response) {
      toast.error("Oops! Something went wrong on our end. We're working to fix it.");
    }

    return { error: error.message, status: error.response.status };
  }
};

const insertQuery = async (data, retryOnFail = false) => {
  const response = await makeRequest(data, retryOnFail);

  if (response.error) {
    // Added this format for retrying a failed 502 request
    throw new Error(`Error ${response.status}: ${response.error}`);
  }

  return response;
};

const updateQuery = async (data) => {
  const response = await makeRequest(data);

  if (response.error) {
    throw new Error(response.error);
  }

  return response;
};

const getQuery = async (data, retryCounts = 1) => {
  const response = await makeRequest(data, true);

  if (response.error) {
    if (response.status === 502 && retryCounts < 3) {
      return await getQuery(data, retryCounts + 1);
    }
    // Added this format for retrying a failed 502 request
    throw new Error(`Error ${response.status}: ${response.error}`);
  }

  return response;
};

const deleteQuery = async (data) => {
  const response = await makeRequest(data);

  if (response.error) {
    throw new Error(response.error);
  }

  return response;
};

const uploadFileQuery = async (data) => {
  const accessToken = getCookie("accessToken");

  try {
    const response = await axios({
      method: "post",

      url: getEnv("UDAS_API"),
      maxBodyLength: Infinity,
      data: data,
      headers: {
        "Content-Type": "multipart/form-data",
        "Apollo-Require-Preflight": true,
        Authorization: "Bearer " + accessToken,
        withCredentials: true
      }
    });

    return response.data.data;
  } catch (error) {
    console.log("error", error);
  }
};

const insertConsoleLogs = async (input, tenant_id) => {
  const data = JSON.stringify({
    query: `
    mutation InsertConsoleLogs($input: [JSON], $tenant_id: String) {
      insertConsoleLogs(input: $input, tenant_id: $tenant_id) {
        isSuccessful
        message
        resultObject
      }
    }
  `,
    variables: {
      input,
      tenant_id
    }
  });

  try {
    const result = await insertQuery(data);

    return result?.insertConsoleLogs;
  } catch (error) {
    console.log("error", error);
  }
};

export { insertQuery, updateQuery, getQuery, deleteQuery, uploadFileQuery, insertConsoleLogs };
